"use client"

import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import { Menu } from 'lucide-react'
import Link from "next/link"

export function MobileNav() {
    return (
        <Sheet>
            <SheetTrigger asChild>
                <button className="md:hidden">
                    <Menu className="h-6 w-6" />
                    <span className="sr-only">Toggle menu</span>
                </button>
            </SheetTrigger>
            <SheetContent side="right" className="p-6 space-y-6">
                <div className="flex justify-center">
                    <Link href="/" className=" text-4xl font-satisfy font-bold">
                        Sucré
                    </Link>
                </div>

                <SheetTitle className="text-xl font-semibold text-left">Menu</SheetTitle>
                <nav className="flex flex-col space-y-2">
                    <Link href="#pedidos" className="text-sm hover:text-gray-600 transition-colors">
                        Pedidos
                    </Link>
                    <Link href="/catalogo" className="text-sm hover:text-gray-600 transition-colors">
                        Catalogo
                    </Link>
                    <Link href="/servicios" className="text-sm hover:text-gray-600 transition-colors">
                        Servicios
                    </Link>
                    <Link href="/galeria" className="text-sm hover:text-gray-600 transition-colors">
                        Galería
                    </Link>
                    <Link href="/acerca" className="text-sm hover:text-gray-600 transition-colors">
                        Sobre Nosotros
                    </Link>
                </nav>
            </SheetContent>
        </Sheet>
    )
}
